module.exports = __webpack_public_path__ + "img/2-4.1f4b56e6.png";